import(/* webpackMode: "eager", webpackExports: ["KitsPageClient"] */ "/app/components/admin/kits/kits-page-client.tsx");
